/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'account-icon': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M10.99 0a11.015 11.015 0 00-8.046 3.513 10.996 10.996 0 001.153 16.048 11.015 11.015 0 008.466 2.329 11.014 11.014 0 006.75-3.687A11 11 0 0010.99 0zM7.844 9.429a3.147 3.147 0 015.37-2.223 3.14 3.14 0 01.682 3.426 3.146 3.146 0 01-6.052-1.204zm7.865 9.727h-.063c-.33.19-.672.357-1.023.503h-.039a9.671 9.671 0 01-7.18 0h-.047a8.803 8.803 0 01-1.023-.503h-.062v-.299c0-1.684.899-3.24 2.359-4.082a4.724 4.724 0 014.718 0 4.714 4.714 0 012.36 4.082v.299zm1.517-1.084a6.288 6.288 0 00-3.452-4.833 4.713 4.713 0 00-2.78-8.523A4.72 4.72 0 006.3 9.918a4.713 4.713 0 001.913 3.321 6.286 6.286 0 00-3.46 4.832 9.422 9.422 0 01-.577-13.6 9.439 9.439 0 0116.241 6.923 9.421 9.421 0 01-3.192 6.678z" _fill="#BECD47"/>'
  }
})
